export default __webpack_public_path__ + "static/media/img-3.5ebd0401.svg";